import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { Platform, ToastController } from '@ionic/angular';
import { State, getState, stateSubject } from 'src/helpers';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  showBanner = false;
  state: State = 'main';
  showTestEnv = location.hostname.includes('staging');

  constructor(
    private swUpdate: SwUpdate,
    private platform: Platform,
    private toastCtrl: ToastController,
    router: Router
  ) {
    platform.ready().then(() => {
      this.initializeApp();
    });

    router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        const newState = getState();
        if (newState !== this.state) {
          this.state = newState;
          stateSubject.next({ state: this.state });
        }
      }
    });
  }

  initializeApp() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe({
        next: (e) => {
          if (e.type === 'VERSION_READY') {
            if (this.platform.is('pwa')) {
              this.showToast();
            } else {
              this.updateToLatest();
            }
          } else if (e.type === 'NO_NEW_VERSION_DETECTED') {
          }
        },
      });
    }

    window.addEventListener('appinstalled', () => {
      // Hide the app-provided install promotion
      // Optionally, send analytics event to indicate successful install
      console.log('PWA was installed');
    });

    const pwaBannerDate = localStorage.getItem('hidePWABanner');
    const hideBannerUntil = new Date(parseInt(pwaBannerDate));

    this.showBanner =
      (this.platform.platforms().includes('mobile') ||
        this.platform.platforms().includes('tablet')) &&
      this.platform.platforms().includes('ios') &&
      !this.platform.platforms().includes('desktop') &&
      !this.platform.is('pwa') &&
      (hideBannerUntil < new Date() || !pwaBannerDate);
  }

  bannerClosed = () => {
    this.showBanner = false;
    const date = new Date();
    date.setDate(date.getDate() + 14);
    localStorage.setItem('hidePWABanner', date.getTime().toString());
  };

  getActiveStageName = () => {
    const path = location.pathname.slice(1);
    if (path.includes('/')) {
      return path.substring(0, path.indexOf('/'));
    }
    return location.pathname.substr(1, location.pathname.length);
  };
  getYear = () => new Date().getFullYear();

  getOffset() {
    return (
      document.getElementById('test-environment-notice')?.clientHeight + 'px'
    );
  }

  showToast() {
    const toast = this.toastCtrl.create({
      message: 'Eine neue Version ist verfügbar',
      cssClass: 'update-toast',
      buttons: [
        {
          text: 'Aktualisieren',
          cssClass: 'toast-button',
          side: 'end',
          handler: () => {
            this.updateToLatest();
          },
        },
      ],
    });

    toast.then((e) => {
      e.present();
    });
  }

  isDesktop() {
    return window.innerWidth >= 992;
  }

  getWidth = () =>
    document.getElementsByTagName('app-navigation')[0].clientWidth + 'px';

  updateToLatest() {
    this.swUpdate.activateUpdate().then(() => {
      console.log('New update available. Updating..');
      document.location.reload();
    });
  }

  clearCookies() {
    const cookies = document.cookie.split(';');
    cookies.forEach((cookie) => {
      if (
        cookie.includes('_gid') ||
        cookie.includes('_ga') ||
        cookie.includes('_gat')
      ) {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }
    });
  }
}
